<div *ngIf="tableData?.length > 0; else noSearchHit" class="fragebogen-app-card-uebersicht">
  <table class="table">
    <caption class="hidden-caption">Liste der Fragebögen</caption>
    <thead #tableHeader>
    <tr class="header-row">
      <th (click)="onSort(header)" (keydown.enter)="onSort(header)" *ngFor="let header of tableHeaders" scope="col"
          tabindex="0">
        <div class="d-flex">
          <p class="header-title">{{header?.name}}</p>
          <em [class.asc]="header.sortDirection === 'asc'" [class.desc]="header.sortDirection === 'desc'"></em>
        </div>
      </th>
      <th *ngIf="tableId === 'entwuerfe'" class="icon-header" scope="col"></th> <!-- header for delete column -->
      <th *ngIf="tableId === 'gesendet'" class="icon-header" scope="col"></th> <!-- header for arrow column -->
    </tr>
    </thead>
    <tbody #tableRowContainer *ngIf="tableData">
    <tr (click)="navigateToAntrag(data.id, $event)" (keydown.enter)="navigateToAntrag(data.id, $event)" (keyup.enter)="navigateToAntrag(data.id, $event)"
        *ngFor="let data of tableData; index as i" [ngClass]="{'border-error':data.status === 'sending_error', 'border-loading':data.status === 'sending' || data.status === 'sending_confirmed'}"
        class="data-row"
        tabindex="0">
      <td>
        <div *ngIf="activeElementIndex === i && showTooltip" class="frageboegen-tooltip">
          <div class="tooltip-dreieck-oben"></div>
          <div class="tooltip-container">
            <p class="tooltip-text">{{toolTipText}}</p>
          </div>
          <div class="tooltip-dreieck-unten"></div>
        </div>
        <div (blur)="onHideTooltip()" (focus)="onShowTooltip(i, 'sending_error')" (mouseout)="onHideTooltip()"
             (mouseover)="onShowTooltip(i, 'sending_error')" *ngIf="data.status === 'sending_error' && tableId === 'entwuerfe'"
             class="icon-container" tabindex="0">
          <em class="icon-fi-fehler"></em>
        </div>
        <div (blur)="onHideTooltip()"
             (focus)="onShowTooltip(i, 'sending_error')"
             (mouseout)="onHideTooltip()" (mouseover)="onShowTooltip(i, 'sending')" *ngIf="(data.status === 'sending' || data.status === 'sending_confirmed' ) && tableId === 'entwuerfe'" class="icon-container"
             id="loader" tabindex="0">
          <common-ui-loader [size]="'sm'"></common-ui-loader>
        </div>
        {{ data?.consultant_number }}
      </td>
      <td>{{ data?.master_client_number }}</td>
      <td>{{ data?.client_name }}</td>
      <td>{{ data?.app_name }}</td>
      <td *ngIf="tableId === 'entwuerfe'">{{ data?.last_changed_on | momentDate }} Uhr</td>
      <td *ngIf="tableId === 'gesendet'">{{ data?.transfer_date | momentDate}} Uhr</td>
      <td *ngIf="tableId === 'entwuerfe' && data.status !== 'sending_confirmed' && data.status !== 'sending'"
          class="td-icon">
        <div class="dropdown">
          <input (click)="toggleDropdown(i, $event)" [class.btn-clicked]="activeElementIndex === i && kebabOpen"
                 class="btn btn-dropdown" data-toggle="dropdown" id="dropdownMenuLink{{i}}"
                 type="button">
          <div *ngIf="activeElementIndex === i && kebabOpen" class="dropdown-menu">
            <a
              (click)="navigateToAntrag(data.id, $event)"
              (keyup.enter)="navigateToAntrag(data.id, $event)"
              class="dropdown-item"
              id="edit"
              tabindex="0">
              {{ 'FRAGEBOEGEN_APP.UEBERSICHT.BEARBEITEN' | translate }}
            </a>
            <a
              (click)="showDeleteDialog(i, $event)"
              (keyup.enter)="showDeleteDialog(i, $event)"
              class="dropdown-item"
              tabindex="0">
              {{ 'COMMON_UI.ENTWURF_LOESCHEN.LOESCHEN' | translate }}
            </a>
          </div>
        </div>
        <div
          *ngIf="activeElementIndex === i && activeDeleteDialog"
          [@slideInOut]
          class="delete-banner d-flex flex-row justify-content-end" id="delete-banner{{i}}">
          <button
            (click)="onDeleteDraft(data?.id, $event)" class="btn btn-danger"
            type="button">{{ 'COMMON_UI.ENTWURF_LOESCHEN.LOESCHEN' | translate }}
          </button>
          <button
            (click)="onCancelDraft($event)" (keyup.enter)="onCancelDraft($event)"
            class="btn btn-default"
            type="button">
            {{ 'COMMON_UI.ENTWURF_LOESCHEN.ABBRECHEN' | translate }}
          </button>
        </div>
      </td>
      <td
        *ngIf="tableId === 'gesendet' || data.status === 'sending' || data.status === 'sending_confirmed'"
        class="td-icon">
        <em class="icon btn-arrow"></em>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<ng-template #noSearchHit>
  <div *ngIf="activeSearch" class="loader-container" id="noContentAntraege">
    <div id="no-content-or-search">
      <div class="mb-1x" id="emptyDocImage"></div>
      <div class="mb-1x mt-2x pr-3x pl-3x" id="noSearchHit">
        <h3>{{ 'FRAGEBOEGEN_APP.UEBERSICHT.SUCHE_HILFE_TEXT' | translate : {value: searchValue} }}</h3>
        <p>{{ 'FRAGEBOEGEN_APP.UEBERSICHT.SUCHE_HINT_TEXT' | translate }}</p>
      </div>
    </div>
  </div>
</ng-template>
